// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { isWeixin, parseQuery } from "@/utils";
import cookie from "@/utils/store/cookie";
import 'swiper/swiper-bundle.css'
// import vConsole from '@/utils/vconsole'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { NoticeBar } from 'vant';
import { Swipe } from 'vant';
import { SwipeItem } from 'vant';
import { TreeSelect } from 'vant';
import { Popup } from 'vant';
import { Search } from 'vant';
import { Toast } from 'vant';
import { image } from 'vant';
import { ActionSheet } from 'vant';
import { Area } from 'vant';
import { Picker } from 'vant';
import { Icon } from 'vant';
import { Lazyload } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { Divider } from 'vant';
Vue.use(Lazyload, {
  lazyComponent: true,
});

Vue.use(Icon);

Vue.use(Picker);
Vue.use(Area);
Vue.use(Divider);

Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(TreeSelect);
Vue.use(Popup);
Vue.use(Search);
Vue.use(Toast);
Vue.use(image);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);



import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;
Vue.config.productionTip = false
Vue.prototype.axios = axios;
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)

let query = parseQuery();
let ref_id = query["ref_id"];
let clear = query['clear']
let source = query['source'] //APP
let token = query['token'] //

if(!!clear) cookie.clearAll();
if(!!source) cookie.set("source", source);
if(!!token) localStorage.setItem("token", token);
if(!!ref_id) {
  cookie.set("ref_id", ref_id || 0);
}

const _isWechat = isWeixin();
if (_isWechat) {
  const module = () => import("@/libs/wechat");
  module().then(Module => {
    Module.default().then(() => { Module.oAuth()});
  });
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js